import './styles.scoped.css'
import {Typography, Button, Modal} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {adminApi} from '../../../../services'
import {parseError} from '../../../../utils/helpers'

export default ({open, setOpen, organization, branch, onDeleted}) => {
    const {setLoading, setMessageBox} = useGlobalStates()

    const handleOk = () => {
        setLoading(true)
        adminApi
            .deleteBranch(organization?.id, branch?.id)
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Organization Branch Deleted Successfully',
                    description: 'This organization branch has been deleted successfully.',
                })
                onDeleted?.()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                setMessageBox({
                    status: 'error',
                    title: title || 'Branch Delete Failed',
                    description: description || 'There was an error deleting this branch. Please try again later.',
                })
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            {`Remove ${branch?.branch_name} from ${organization?.name}`}
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        Are you sure you want to remove this branch? This action cannot be undone, and the document will be permanently deleted.
                    </Typography>
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={handleOk}>
                            Remove Branch
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
